
// TODO: Localize size breakpoints so themes can adjust
const SIZES = {
  card: {
    xl: 900,
    lg: 630,
    md: 520,
    sm: 400,
  },
  times: {
    lg: 400,
    md: 300,
    sm: 250,
  }
}

function applySizeClasses(root, cardWidth) {
  const mvRecipeCardTimes = root.getElementsByClassName('mv-create-times')[0]

  if ( mvRecipeCardTimes ) {
    const timesWidth = mvRecipeCardTimes.scrollWidth
    let mvRecipeTimesSize = 'xl'
    if ( timesWidth < SIZES.times.lg ) mvRecipeTimesSize = 'lg'
    if ( timesWidth < SIZES.times.md ) mvRecipeTimesSize = 'md'
    if ( timesWidth < SIZES.times.sm ) mvRecipeTimesSize = 'sm'

    mvRecipeCardTimes.classList.remove( 'mv-create-times-sm', 'mv-create-times-md', 'mv-create-times-lg', 'mv-create-times-xl' )
    mvRecipeCardTimes.classList.add( 'mv-create-times-' + mvRecipeTimesSize )
  }

  let mvRecipeCardSize = 'xxl'
  if ( cardWidth < SIZES.card.xl ) mvRecipeCardSize = 'xl'
  if ( cardWidth < SIZES.card.lg ) mvRecipeCardSize = 'lg'
  if ( cardWidth < SIZES.card.md ) mvRecipeCardSize = 'md'
  if ( cardWidth < SIZES.card.sm ) mvRecipeCardSize = 'sm'

  root.classList.remove( 'mv-create-sm', 'mv-create-md', 'mv-create-lg', 'mv-create-xl', 'mv-create-xxl' )
  root.classList.add( 'mv-create-' + mvRecipeCardSize )
}

export const sizeRecipeCard = (root= null) => {

  if (!root) {
    return
  }

  // Change mv-no-js to js class
  root.className = root.className.replace(/\bmv-no-js\b/,'js')

  if (window.ResizeObserver) {
    const ro = new ResizeObserver(entries => {
      for (const entry of entries) {
        applySizeClasses(root, entry.contentRect.width)
      }
    })
    ro.observe(root)
  } else {
    // Fallback: read scrollWidth then write classes, debounced on resize
    function mvRecipeCardSizeClass() {
      applySizeClasses(root, root.scrollWidth)
    }
    mvRecipeCardSizeClass()
    function mvResizeTimer() {
      window.clearTimeout(window.mvResizeTimer)
      window.mvResizeTimer = window.setTimeout(mvRecipeCardSizeClass, 100)
    }
    window.addEventListener('resize', mvResizeTimer, {passive: true})
  }
}

export default sizeRecipeCard
